import React from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Tooltip } from 'recharts';
interface AbilityRadarChartProps {
  abilities: {
    regionalKnowledge: number;
    foodDining: number;
    shoppingMarkets: number;
    culturalActivities: number;
    adventureOutdoor: number;
    luxuryServices: number;
    budgetPlanning: number;
    languageSkills: number;
  };
}
export const AbilityRadarChart: React.FC<AbilityRadarChartProps> = ({
  abilities
}) => {
  // Format the data for the radar chart
  const data = [{
    subject: 'Regional Knowledge',
    value: abilities.regionalKnowledge,
    fullMark: 100,
    description: 'Knowledge of local geography, history, and customs'
  }, {
    subject: 'Food & Dining',
    value: abilities.foodDining,
    fullMark: 100,
    description: 'Expertise in local cuisine and dining experiences'
  }, {
    subject: 'Shopping & Markets',
    value: abilities.shoppingMarkets,
    fullMark: 100,
    description: 'Knowledge of shopping districts and local markets'
  }, {
    subject: 'Cultural Activities',
    value: abilities.culturalActivities,
    fullMark: 100,
    description: 'Understanding of cultural events, museums, and traditions'
  }, {
    subject: 'Adventure & Outdoor',
    value: abilities.adventureOutdoor,
    fullMark: 100,
    description: 'Ability to guide outdoor and adventure activities'
  }, {
    subject: 'Luxury Services',
    value: abilities.luxuryServices,
    fullMark: 100,
    description: 'Knowledge of premium experiences and services'
  }, {
    subject: 'Budget Planning',
    value: abilities.budgetPlanning,
    fullMark: 100,
    description: 'Skill in planning tours within budget constraints'
  }, {
    subject: 'Language Skills',
    value: abilities.languageSkills,
    fullMark: 100,
    description: 'Proficiency in local and international languages'
  }];
  // Custom tooltip component
  const CustomTooltip = ({
    active,
    payload
  }: any) => {
    if (active && payload && payload.length) {
      return <div className="bg-slate-800 p-3 border border-slate-700 rounded shadow-lg" data-id="element-10">
          <p className="font-bold text-white" data-id="element-11">{payload[0].payload.subject}</p>
          <p className="text-blue-400" data-id="element-12">{`Value: ${payload[0].value}`}</p>
          <p className="text-xs text-gray-300 mt-1" data-id="element-13">
            {payload[0].payload.description}
          </p>
        </div>;
    }
    return null;
  };
  return <ResponsiveContainer width="100%" height="100%" data-id="element-14">
      <RadarChart outerRadius="80%" data={data} data-id="element-15">
        <PolarGrid stroke="#4b5563" data-id="element-16" />
        <PolarAngleAxis dataKey="subject" tick={{
        fill: '#e2e8f0',
        fontSize: 10
      }} data-id="element-17" />
        <PolarRadiusAxis angle={30} domain={[0, 100]} tick={{
        fill: '#94a3b8'
      }} data-id="element-18" />
        <Radar name="Abilities" dataKey="value" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} data-id="element-19" />
        <Tooltip content={<CustomTooltip data-id="element-21" />} data-id="element-20" />
      </RadarChart>
    </ResponsiveContainer>;
};